import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';

const BASE = 'table-box';
export const INIT_GRID = BASE + PATH_DELIMITER + 'INIT_GRID';
export const SET_CONTROL = BASE + PATH_DELIMITER + 'SET_CONTROL';
export const SET_GRID_DATA = BASE + PATH_DELIMITER + 'SET_GRID_DATA';

export const initGrid = createAction(INIT_GRID);
export const handleControl = createAction(SET_CONTROL);
export const handleGridData = createAction(SET_GRID_DATA);

export const defaultControl = {
    columns: [],
    onChangePageInfo: null,
    onRowDoubleClick: null,
    onRowClick: null,
    params: {},
};

export const defaultGridData = {
    rows: [],
    page: 0,
    pageSize: 100,
    totalCount: 0,
};

export const defaultPageSize_10 = 10;

const initialState = {
    gridData: defaultGridData,
    control: defaultControl,
};

const module = handleActions(
    {
        [INIT_GRID]: () => initialState,
        [SET_CONTROL]: (state, { payload: control }) => ({ ...state, control }),
        [SET_GRID_DATA]: (state, { payload: gridData }) => ({ ...state, gridData }),
    },
    initialState,
);

export default module;
